import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=5e6c028e&"
import script from "./TableWrapper.vue?vue&type=script&lang=js&"
export * from "./TableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TableWrapper.vue?vue&type=style&index=0&id=5e6c028e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports